import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';
import Button from './Button';
import Input from './Input';
import { clientsAPI } from '../services/api';
import { useToast } from '../contexts/ToastContext';

const INITIAL = { name: '', contactPhone: '', contactEmail: '' };

const PeseurPonctuelClientModal = ({ isOpen, onClose, onClientCreated }) => {
  const { t } = useTranslation();
  const toast = useToast();
  const [form, setForm] = useState(INITIAL);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    setForm(INITIAL);
  }, [isOpen]);

  const handleClose = () => {
    if (loading) return;
    onClose?.();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name?.trim() || !form.contactPhone?.trim()) {
      toast.error(t('clients.fillRequired'));
      return;
    }
    setLoading(true);
    try {
      const res = await clientsAPI.peseurPonctuelCreate({
        name: form.name.trim(),
        contactPhone: form.contactPhone.trim(),
        contactEmail: form.contactEmail?.trim() || undefined
      });
      toast.success(t('clients.ponctuelClientCreated'));
      onClientCreated?.(res?.data?.client ?? null);
      handleClose();
    } catch (err) {
      toast.error(err?.response?.data?.message || err?.response?.data?.errors?.[0]?.msg || t('common.error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title={t('clients.ponctuelModalTitle')}
      size="md"
      closeOnOverlayClick={!loading}
      footer={
        <>
          <Button variant="outline" onClick={handleClose} disabled={loading}>
            {t('common.cancel')}
          </Button>
          <Button type="submit" form="ponctuel-client-form" loading={loading}>
            {t('clients.ponctuelModalSubmit')}
          </Button>
        </>
      }
    >
      <p className="text-sm text-gray-600 mb-4">{t('clients.ponctuelModalHint')}</p>
      <form id="ponctuel-client-form" onSubmit={handleSubmit} className="space-y-4">
        <Input
          label={t('clients.contactName')}
          name="name"
          value={form.name}
          onChange={handleChange}
          required
          autoComplete="name"
        />
        <Input
          label={t('clients.contactPhone')}
          name="contactPhone"
          type="tel"
          value={form.contactPhone}
          onChange={handleChange}
          required
          autoComplete="tel"
        />
        <Input
          label={`${t('clients.contactEmail')} (${t('common.optional', { defaultValue: 'optionnel' })})`}
          name="contactEmail"
          type="email"
          value={form.contactEmail}
          onChange={handleChange}
          autoComplete="email"
        />
      </form>
    </Modal>
  );
};

export default PeseurPonctuelClientModal;
